export enum ButtonLayout {
  Column = 'Column',
  RowWrap = 'RowWrap',
}

export interface ButtonConfiguration {
  layout?: ButtonLayout
  font?: string | null

  /** @pattern #[0-9A-Fa-f]{6} */
  fontColor?: string | null

  /** @format int32 */
  fontSize?: number
  fontBold?: boolean
  fontItalic?: boolean

  /** @pattern #[0-9A-Fa-f]{6} */
  color?: string | null

  /** @pattern #[0-9A-Fa-f]{6} */
  borderColor?: string | null

  /** @format int32 */
  width?: number

  /** @format int32 */
  height?: number

  /** @format int32 */
  margin?: number

  /** @format int32 */
  borderRadius?: number

  /** @format int32 */
  borderSize?: number
}

export enum ControlsPosition {
  Top = 'Top',
  Bottom = 'Bottom',
}

export enum ImageFit {
  Contain = 'Contain',
  Cover = 'Cover',
  Fill = 'Fill',
  None = 'None',
}

export enum Layout {
  Column = 'Column',
  ColumnReverse = 'ColumnReverse',
  Row = 'Row',
  RowReverse = 'RowReverse',
}

export interface LayoutConfiguration {
  /** @pattern #[0-9A-Fa-f]{6} */
  backgroundColor?: string | null

  /** @pattern #[0-9A-Fa-f]{6} */
  headerColor?: string | null

  /** @pattern #[0-9A-Fa-f]{6} */
  headerFontColor?: string | null

  /** @pattern #[0-9A-Fa-f]{6} */
  accentColor?: string | null
  controlsPosition?: ControlsPosition
  layout?: Layout
  imageFit?: ImageFit
}

export interface WebPlayer {
  title: string
  subtitle: string
  logo: string
  chirp: string
  cover: string
  live: boolean

  /** @format int32 */
  iframeHeight: number

  /** @format int32 */
  iframeWidth: number
  voiceDisabled: boolean
  hideDefaultButtons: boolean
  layoutConfiguration: LayoutConfiguration
  buttonConfiguration: ButtonConfiguration
  projectId: string
  locale: string
}

export interface PlatformSettingsWeb {
  title: string
  subtitle: string
  logo: string
  chirp: string
  cover: string
  live: boolean

  /** @format int32 */
  iframeHeight: number

  /** @format int32 */
  iframeWidth: number
  voiceDisabled: boolean
  hideDefaultButtons: boolean
  layoutConfiguration: LayoutConfiguration
  buttonConfiguration: ButtonConfiguration
}
